import React from 'react'

export default ({ children }) => (
  <section
    className="hero is-fullheight center-layout"
    style={{
      backgroundImage: 'radial-gradient(#207c56, #60a186)',
    }}
  >
    <div className="hero-body">
      <div className="container">
        <div className="columns">
          <div className="column is-10-tablet is-offset-1-tablet is-6-desktop is-offset-3-desktop">
            {children}
          </div>
        </div>
      </div>
    </div>
  </section>
)
